import { Alert, AlertTitle, Box } from "@mui/material";

interface EmptyStateProps {
  title?: string;
  message?: string;
  showEndpointHint?: boolean;
}

export function EmptyState({
  title = "No Data Available",
  message = "There is no data to display.",
  showEndpointHint = false,
}: EmptyStateProps) {
  return (
    <Box sx={{ p: 4 }}>
      <Alert severity={showEndpointHint ? "info" : "warning"}>
        <AlertTitle>{title}</AlertTitle>
        {message}
        {showEndpointHint && import.meta.env.DEV && (
          <Box sx={{ mt: 1, fontSize: "0.875rem" }}>
            💡 <strong>Development Tip:</strong> This endpoint may not be
            implemented yet. The frontend is ready to display data once the
            backend API is available.
          </Box>
        )}
      </Alert>
    </Box>
  );
}
